/**
 * Application
 */

// React
import React from 'react';
import { BrowserRouter } from 'react-router-dom';

// Recoil
import { RecoilRoot } from 'recoil';

// Material config
import { ThemeProvider } from '@mui/material/styles';
import { lightTheme } from 'configs/theme';

// Components
import AppRouter from 'app/AppRouter';

// Render application
const App: React.FC = () => {
  return (
    <ThemeProvider theme={lightTheme}>
      <RecoilRoot>
        <BrowserRouter>
          <AppRouter />
        </BrowserRouter>
      </RecoilRoot>
    </ThemeProvider>
  );
};

export default App;
